<!-- 资源列表 -->
<template>
  <div class='resource-wrap' v-loading="loading" >
    <div class="content">
      <el-table :data="tableData" style="width: 100%"  class="resourceTable">
        <el-table-column prop="sourceInfo" label="节点类型" width="150" align="center" v-if="!gpuType" sortable></el-table-column>
        <el-table-column :formatter="gpuTypeData" label="节点类型" width="150" align="center" v-if="gpuType" sortable></el-table-column>
        <el-table-column prop="sourceInfo" label="节点IP" width="150" align="center" v-if="gpuType" sortable></el-table-column>
        <el-table-column prop="gpuLeft"  label="剩余GPU" align="center" sortable></el-table-column>
        <el-table-column prop="gpuTotal" label="GPU总量" align="center" sortable></el-table-column>
        <el-table-column prop="cpuLeft" label="剩余CPU" align="center" sortable></el-table-column>
        <el-table-column prop="cpuTotal" label="CPU总量" align="center" sortable></el-table-column>
        <el-table-column prop="memLeft" label="剩余内存" align="center" sortable></el-table-column>
        <el-table-column prop="memTotal" label="内存总量(MB)" align="center" width="150" sortable></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text"  @click="showDetail(scope.row.sourceInfo)" v-if="!gpuType">
              <span>查看详情</span>
            </el-button>
            <el-button type="text"  @click="toOverview()" v-else>
              <span>返回概览</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="unavailable">
        <el-popover
          placement="left"
          width="326"
          trigger="hover">
          <el-table :data="unavailableData" :row-style="rowStyle">
            <el-table-column width="120" property="nodeIP" label="节点IP"></el-table-column>
            <el-table-column width="180" align="left" property="unHealthyGPU" label="屏蔽卡号"></el-table-column>
          </el-table>
          <el-button slot="reference" type="text" style="text-align:left;padding-bottom: 0px;">
            <div class="consume-item-count-link">
              <a>已屏蔽GPU卡</a>
            </div>
          </el-button>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { resourcesInfo, unavailable } from '../../api/project'
export default {
// import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      tableData: [],
      gpuType: '',
      loading: true,
      unavailableData: []
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 返回概览
    toOverview () {
      this.$router.push({
        name: 'resource'
      })
      this.gpuType = ''
      this.resourceInfo()
    },
    // 获取详情
    showDetail (type) {
      this.$router.push({
        name: 'resourceDetail',
        params: {
          gpuType: type
        }
      })
      this.gpuType = type
      this.resourceInfo()
    },
    // 表单展示的GPU类型
    gpuTypeData () {
      return this.gpuType
    },
    getUnavailableGPU () {
      unavailable().then(res => {
        if (res.message.code === 0) {
          this.unavailableData = res.data
        }
      })
    },
    resourceInfo () {
      this.loading = true
      let param = '?GPUType='
      if (this.gpuType) {
        param = param + this.gpuType
      }
      resourcesInfo(param).then(res => {
        if (res.message.code === 0) {
          this.tableData = res.data
        }
        this.loading = false
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.gpuType = this.$route.params.gpuType
    this.resourceInfo()
    this.getUnavailableGPU()
  },
  // 生命周期 - 创建之前
  beforeCreate () {},
  // 生命周期 - 挂载之前
  beforeMount () {},
  // 生命周期 - 更新之前
  beforeUpdate () {},
  // 生命周期 - 更新之后
  updated () {},
  // 生命周期 - 销毁之前
  beforeDestroy () {},
  // 生命周期 - 销毁完成
  destroyed () {},
  // 如果页面有keep-alive缓存功能，这个函数会触发
  activated () {}
}
</script>
<style lang="stylus" scoped>
//@import url(); 引入公共css类
/deep/ .el-table td
  padding 2px 0
.resource-wrap
  width 100%
  .content
    width 1162px
    margin 0 auto
    padding 20px 0
    .pagination
      width 100%
      padding 10px 0
      background #ffffff
      text-align right
    .unavailable
      text-align right
      font-size 14px
      color #409eff
      padding-top 4px
      padding-right 34px
</style>
